import data_api from "./data_api";
import store from '@/store/index'
import utils from "./utils"

data_api.init();

export const init = () => {
    data_api.nft.index()
    .then((resp) => {
      utils.console.log("nft index resp: ", resp);
    //   utils.console.log("team index resp results: ", resp.data.data.response);
      // // set store leases data
      // store.state.leases.list.concat(resp.data);
      store.set("nft/list", resp);
      utils.console.log("store nft list fater init: ", store.state.nft.list);
    })
    .catch((error) => {
      console.error("nft index faild: ", error)
    });

}

